export class FaqModel {
  constructor(
    public id: Number,
    public answer: string,
    public category: string,
    public question: string,
    public sort: Number,
    public webUrl?: string | null
  ) {
  }
}

export enum Step {
  Topics = 1,
  Location = 2,
  Experience = 3,
  ContactInfo = 4
}

export interface SubmitFeedBack {
  firstName: string;
  lastName: string;
  accountEmail: string | null;
  email: string;
  phoneNumber: string;
  locationUnitNumber: number;
  visitDate: Date | null;
  timeOfDay: TimeOfDay;
  serviceType: number;
  comments: string;
  source: SourceType;
  attachment: string;
  posOrderNo: string | null;
  attachmentName: string;
  topicType: topicType;
  contactBy: contactMedium;
  problemCategories: string[];
  problemItems?: any[];
  isOnlineOrder: boolean;
  version?: string;
  orderItems?: any[];
  orderId: string | null;
  isItAboutALocation?: boolean | null;
  orderPlacedDate?: string | null;
  feedbackCategoryInfo: {
    feedbackCategories: FeedbackCategory[] | {};
    feedbackSubCategories: FeedbackSubCategory[] | {};
    additionalFeedbacks: FeedbackAdditional[] | {};
  }
}

export interface FeedbackCategory {
  id: number;
  name: string;
}

export interface FeedbackSubCategory {
  id: number;
  name: string;
}

export interface FeedbackAdditional {
  id: number;
  name: string;
}

export enum locSelected {
  yes = 5458,
  no = 5459,
}

export enum contactMedium {
  Email = 5901,
  Phone = 5902,
  No = 5903,
}

export enum topicType {
  Compliment = 2342,
  // Request= 2343, // Future use
  Suggestion = 2344,
  Problem = 2345, // Future use
  // Other = 2346,

}

export enum TimeOfDay {
  NoTimeProvided = 5894,
  EarlyMorning = 5895,
  Breakfast = 5896,
  Lunch = 5897,
  MidDay = 5898,
  Dinner = 5899,
  LateNight = 5900
}

export enum ContactBy {
  Email = 5901,
  Phone = 5902,
  NoContact = 5903
}

export enum SourceType {
  Web = 1,
  Mobile = 2
}


export enum occuranceTimeAnswer {
  'No Time Provided' = 5894,
  'Early Morning 12:01am - 6:00am' = 5895,
  'Breakfast 6:01am - 11:00am' = 5896,
  'Lunch 11:01am - 2:00pm' = 5897,
  'Mid-Day 2:01pm - 5:00pm' = 5898,
  'Dinner 5:01pm - 10:00pm' = 5899,
  'Late Night 10:01pm - 12:00am' = 5900
}

export enum PickUpMethod {
  'Dine In' = 40,
  'Take Out' = 44,
  'Drive Thru' = 45,
  'Did Not Visit' = 46,
  'Unknown' = 452,
  'Mobile Order (APP)' = 483,
  'Curbside' = 552,
  'Delivery' = 553
}

export interface FeedbackValues {
  problemCategories: ContactUsProblemCategory[];
}

export class ContactUsProblemCategory {
  id: number;
  name: string;
  value: string;
  requiresOnlineOrdering: boolean;
}

export enum ContactUsProblemTime {
  NO_TIME = 'No Time Provided',
  EARLY_MORNING = 'Early Morning 12:01am - 6:00am',
  BREAKFAST = 'Breakfast 6:01am - 11:00am',
  LUNCH = 'Lunch 11:01am - 2:00pm',
  MID_DAY = 'Mid-Day 2:01pm - 5:00pm',
  DINNER = 'Dinner 5:01pm - 10:00pm',
  LATE_NIGHT = 'Late Night 10:01pm - 12:00am'
}

export enum ContactUsProblemTimeValue {
  NO_TIME = 'NoTimeProvided',
  EARLY_MORNING = 'EarlyMorning',
  BREAKFAST = 'Breakfast',
  LUNCH = 'Lunch',
  MID_DAY = 'MidDay',
  DINNER = 'Dinner',
  LATE_NIGHT = 'LateNight',
}

export enum ContactUsProblemPickUpMethod {
  DINE_IN = 'Dine In',
  DRIVE_THROUGH = 'Drive Thru',
  TAKE_OUT = 'Take Out',
  NO_PICKUP = `I didn't get any food`

}

export enum ContactUsProblemPickUpMethodValues {
  DINE_IN = 40,
  DRIVE_THROUGH = 45,
  DELIVERY = 553,
  TAKE_OUT = 44,
  NO_PICKUP = 46,
  UNKNOWN = 452
}

export interface ContactUsOrderProblemCategory {
  id: number;
  title: string;
  subTitle?: string;
  subCategoryInfo?: ContactUsOrderProblemSubCategory[];
  additionalInfo?: ContactUsOrderProblemAdditionalInfo[];
}

export interface ContactUsOrderProblemSubCategory {
  id: number;
  title: string;
  subTitle: string;
}

export interface ContactUsOrderProblemAdditionalInfo {
  id: number;
  title: string;
}


export interface ContactUsFeedbackResponse {
  id: number;
  reportNumber: number;
}
